<template>
  <div>
    <heads title="活动编辑" @submit="submit('ruleForm')"></heads>
    <div class="actEdit-content add-imgText-content">
      <el-scrollbar style="height: 100%" ref="myScrollbar">
        <el-form :model="reqData" ref="ruleForm" class="search-form" :rules="rules">
          <el-row>
            <el-col :span="16">
              <div>
                <el-row>
                  <el-col :span="12">
                    <div>
                      <div class="sub-title">
                        标题图
                        <span>（建议尺寸1078*606像素，图片大小不超过2M）</span>
                      </div>
                      <div class="upload-box">
                        <el-form-item prop="activityPicture">
                          <upload-cropper @getPath="getPath" :url="reqData.activityPicture"></upload-cropper>
                        </el-form-item>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <el-row>
                      <div>
                        <div class="sub-title">活动主题</div>
                        <el-form-item prop="activityTheme">
                          <el-input v-model="reqData.activityTheme" placeholder="添加分类" size="small"></el-input>
                        </el-form-item>
                      </div>
                    </el-row>
                    <el-row>
                      <el-col :span="18">
                        <div>
                          <div class="sub-title">活动招募截止时间</div>
                          <el-form-item prop="siginUpEndTimeStr">
                            <el-date-picker v-model="reqData.siginUpEndTimeStr" type="datetime" size="small"
                              placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                          </el-form-item>
                        </div>
                        <div>
                          <div class="sub-title">活动起止时间</div>
                          <el-form-item prop="time">
                            <el-date-picker v-model="reqData.time" type="datetimerange" size="small"
                              start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div>
                          <div class="sub-title">活动积分</div>
                          <el-form-item prop="activityPoint">
                            <el-input-number v-model="reqData.activityPoint" controls-position="right" :min="0"
                              placeholder="添加分类" size="small"></el-input-number>
                          </el-form-item>
                        </div>
                        <div>
                          <div class="sub-title">活动招募人数</div>
                          <el-form-item prop="activityRecruitsNum">
                            <el-input-number v-model="reqData.activityRecruitsNum" controls-position="right" :min="0"
                              placeholder="添加分类" size="small"></el-input-number>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row>
                  <div>
                    <div class="sub-title">分类</div>
                    <el-form-item prop="activityKindId">
                      <div class="type-item">
                        <el-radio-group v-model="reqData.activityKindId">
                          <el-radio :label="item.id" v-for="(item,index) in typeList" :key="index">
                            {{item.activityKindName}}</el-radio>
                        </el-radio-group>
                        <el-input v-model="activityKindName" placeholder="添加分类" size="small" @blur="addType"
                          @keyup.enter.native="addType"></el-input>
                      </div>
                    </el-form-item>
                  </div>
                </el-row>
                <el-row>
                  <div class="editor-box">
                    <el-form-item prop="activityContent">
                      <editor ref="activityEditor" :content="reqData.activityContent"></editor>
                    </el-form-item>
                  </div>
                </el-row>
              </div>
            </el-col>
            <el-col :span="8">
              <aside class="position">
                <div class="sub-title">活动地点</div>
                <el-form-item prop="activityPlace">
                  <el-input v-model="reqData.activityPlace" placeholder="请输入活动地点" size="small" @blur="searchPlace"
                    @keyup.enter.native="searchPlace">
                    <i class="el-icon-search el-input__icon" slot="suffix" @click="searchPlace"></i>
                  </el-input>
                </el-form-item>
                  <div class="map-box">
                    <baidu-map class="map" :center="center" :zoom="zoom">
                      <bm-view class="map"></bm-view>
                      <bm-local-search :keyword="keyWord" :auto-viewport="true" :location="myCity" class="addressList"
                        @infohtmlset="addressDetail"></bm-local-search>
                    </baidu-map>
                  </div>
               
              </aside>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
  import heads from '@/components/header.vue';
  import uploadCropper from '@/components/uploadCropper.vue';
  import editor from '@/components/editor.vue';
  import api from '@/api/peopleOnline/volunteer.js';
  export default {
    components: { heads, uploadCropper, editor },
    data() {
      return {
        typeList: [], //分类
        activityKindName: '', //新添分类
        reqData: {
          time: [],
          activityTheme: 12,
          siginUpEndTimeStr: '',
          activityStartTimeStr: '2019-07-09 00:00',
          activityEndTimeStr: '2019-07-25 00:00',
          activityPlace: '',
          longitude: '',
          latitude: '',
          activityPicture: '',
          activityContent: '',
          activityRecruitsNum: 0,
          activityPoint: 0,
          activityKindName: '',
          activityKindId: '',
          communityId: '',
        },
        rules: {
          activityPicture: [{ required: true, message: "请上传标题图片", trigger: "change" }],
          activityTheme: [
            { required: true, message: "请输入活动主题", trigger: "blur" }
          ],
          siginUpEndTimeStr: [
            { required: true, message: "请选择活动招募时间", trigger: "change" }
          ],
          time: [
            { required: true, message: "请选择活动起止时间", trigger: "change" }
          ],
          activityPoint: [
            { required: true, message: "请输入活动积分", trigger: "blur" }
          ],
          activityRecruitsNum: [
            { required: true, message: "活动招募人数", trigger: "blur" }
          ],
          activityKindId: [
            { required: true, message: "请选择活动分类", trigger: "change" }
          ],
          activityPlace: [
            { required: true, message: "请输入活动地点", trigger: "blur" }
          ],
          activityContent: [
            { required: true, message: "请输入活动内容", trigger: "change" }
          ],
        },
        // 百度地图相关数据
        center: { lng: 104.062, lat: 30.556 },
        zoom: 15,
        keyWord: '',
        myCity: ''
      };
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      id() {
        return this.$route.query.id;
      }
    },
    mounted() {
      this.reqData.communityId = this.userInfo.communityId;
      this.getTypeList();
      if (this.id !== undefined) {
        this.getActivityInfo();
      }
    },
    methods: {
      // 编辑获取活动详情
      async getActivityInfo() {
        let res = await this.$http.get(`${api.activityInfo}?id=${this.id}`);
        if (res && res.isSucceed) {
          let data = res.rows && res.rows.length > 0 ? res.rows[0] : {};
          for (let key in this.reqData) {
            if (data.hasOwnProperty(key)) {
              this.reqData[key] = data[key];
            }
          }
          let time = [data.activityStartTimeStr, data.activityEndTimeStr];
          this.reqData.time = [...time];
          this.reqData.activityKindId = Number(this.reqData.activityKindId)
          this.searchPlace();
        }
      },
      // 上传获取图片路径
      getPath(data) {
        this.reqData.activityPicture = data.path;
      },
      // 获取分类列表
      async getTypeList() {
        let data = {
          page: 1,
          rows: 100,
          communityId: this.userInfo.communityId
        };
        let res = await this.$http.get(`${api.typeList}`, { params: data });
        if (res && res.isSucceed) {
          this.typeList = res.rows;
        }
      },
      // 新增分类
      async addType() {
        if (this.activityKindName==='') {
          this.$message.error('请输入要添加的分类');
          return;
        }
        let res = await this.$http.post(
          api.addType,
          this.$qs.stringify({ activityKindName: this.activityKindName, communityId: this.userInfo.communityId })
        );
        if (res && res.isSucceed) {
          this.activityKindName = '';
          this.getTypeList();
        }
      },
      // 搜索地址
      searchPlace() {
        let _this = this;
        let city = new BMap.LocalCity();
        city.get(result => {
          _this.myCity = result.name;
          _this.keyWord = _this.reqData.activityPlace;
        });
      },
      // 获取所选地址详情
      addressDetail(info) {
        this.reqData.activityPlace = info.address;
        this.reqData.latitude = info.point.lat;
        this.reqData.longitude = info.point.lng;
      },
      submit(formName) {
        this.reqData.activityContent = this.$refs.activityEditor.getContent();
        this.$refs[formName].validate(async valid => {
          if (!valid) return;
          let data = JSON.parse(JSON.stringify(this.reqData));
          if (this.id !== undefined) {
            data.id = this.id;
          }
          data.activityStartTimeStr =
            data.time && data.time.length > 0 ? data.time[0] : '';
          data.activityEndTimeStr =
            data.time && data.time.length > 0 ? data.time[1] : '';
          delete data.time;
          let res = await this.$http.post(
            api.addACctivity,
            this.$qs.stringify(data)
          );
          if (res && res.isSucceed) {
            this.$router.push('/peopleOnline/volunteer');
          }

        })

      }
    }
  };
</script>
<style lang='less' scoped>
  .actEdit-content {
    height: 800px;
    margin-top: 20px;
    padding: 0px 0 20px 20px;
    background: #fff;

    .type-item {
      display: flex;
    }

    .upload-box {
      width: 70%;
    }

    .editor-box {
      margin-top: 20px;
    }

    aside {
      margin-left: 30px;
      padding-right: 25px;

      .map-box {
        height: 275px;
        margin-top: 20px;

        .map {
          height: 100%;
        }
      }
    }
  }
</style>
<style lang='less'>
  @import url('./ele-add.less');
</style>